import { fromGqlId } from "@src/api/formatters/shopify";
import {
  FetchProductPickerProductsDocument,
  FetchProductPickerProductsQuery,
  FetchProductPickerProductsQueryVariables,
} from "@src/generated";
import { shopifyGqlClient } from "@src/providers/gqlProvider";
import { ProductPickerProduct } from "@src/store/slices/productPicker/types";

export async function loadProducts(
  variables: FetchProductPickerProductsQueryVariables,
  allowIgProducts?: boolean
) {
  const result = await shopifyGqlClient.query<
    FetchProductPickerProductsQuery,
    FetchProductPickerProductsQueryVariables
  >({
    query: FetchProductPickerProductsDocument,
    variables,
    fetchPolicy: "network-only",
  });

  const data: ProductPickerProduct[] = result.data.products.edges.map((e) => ({
    id: fromGqlId(e.node.id),
    title: e.node.title,
    image: e.node.featuredImage?.url as string | undefined,
    handle: e.node.handle,
    status: e.node.status,
    hasVariantsThatRequiresComponents: e.node.hasVariantsThatRequiresComponents,
    sellingPlanGroupCount: e.node.sellingPlanGroupCount,
    requiresSellingPlan: e.node.requiresSellingPlan,
    isBundle:
      e.node.bundleComponents.nodes.length > 0 ||
      e.node.hasVariantsThatRequiresComponents,
    tags: e.node.tags,
  }));

  // filter out ig duplicates since we can't do it with the explicit query
  if (!allowIgProducts && variables.query?.includes("collection_id")) {
    const filteredData: ProductPickerProduct[] = data.filter(
      (product) => !product.tags?.includes("price_test")
    );

    return {
      data: filteredData,
      endCursor: result.data.products.pageInfo.endCursor ?? undefined,
      hasNextPage: result.data.products.pageInfo.hasNextPage,
    };
  }

  return {
    data,
    endCursor: result.data.products.pageInfo.endCursor ?? undefined,
    hasNextPage: result.data.products.pageInfo.hasNextPage,
  };
}
